export const LOI_MIN = 1;
export const LOI_MAX = 60;

export const FIELD_TIME_MIN = 1;
export const FIELD_TIME_MAX = 999;

export const INTEGER_PATTERN = /^\d+$/;
export const INTEGER_DIGIT_RESTRICTION_PATTERN = /^\d{1,2}$/;
